module.exports = __webpack_public_path__ + "img/cooler-master-caliber-r1-preview.149d7725.png";